import { apiGet, apiPost } from './index'

export type IntegrationStatus = 'ok' | 'not_configured' | 'corrupt'

export interface IntegrationProvider {
  id: string
  name: string
  status: IntegrationStatus
  settings: Record<string, unknown>
  error?: string | null
}

export interface IntegrationsResponse {
  providers: IntegrationProvider[]
}

export interface TestIntegrationResponse {
  ok: boolean
  details?: string
  error?: string
}

export const getIntegrations = async (stationId: number): Promise<IntegrationsResponse> => {
  return apiGet<IntegrationsResponse>(`integrations?station_id=${stationId}`)
}

export interface SaveIntegrationResponse {
  ok: boolean
}

export interface TelegramWebhookResponse {
  ok: boolean
  webhook_url?: string
  token_hash?: string
  username?: string | null
  username_error?: string
}

export interface TelegramInfoResponse {
  ok: boolean
  username?: string | null
  webhook_url?: string
  token_hash?: string
  username_error?: string
  error?: string
}

export const saveIntegration = async (
  providerId: string,
  stationId: number,
  settings: Record<string, unknown>,
): Promise<SaveIntegrationResponse> => {
  return apiPost<SaveIntegrationResponse>(`integrations/${providerId}`, {
    station_id: stationId,
    settings,
  })
}

export const testIntegration = async (
  providerId: string,
  stationId: number,
): Promise<TestIntegrationResponse> => {
  return apiPost<TestIntegrationResponse>(`integrations/${providerId}/test`, {
    station_id: stationId,
  })
}

export const testEmailSmtp = async (
  stationId: number,
  settings: Record<string, unknown>,
): Promise<TestIntegrationResponse> => {
  return apiPost<TestIntegrationResponse>('integrations/email/test-smtp', {
    station_id: stationId,
    settings,
  })
}

export const setTelegramWebhook = async (stationId: number): Promise<TelegramWebhookResponse> => {
  return apiPost<TelegramWebhookResponse>('integrations/telegram/set-webhook', {
    station_id: stationId,
  })
}

export const getTelegramInfo = async (stationId: number): Promise<TelegramInfoResponse> => {
  return apiGet<TelegramInfoResponse>(`integrations/telegram/info?station_id=${stationId}`)
}
